(function () {
  function init() {
    var nativeGrid = document.querySelector('.collection-grid__wrapper');
    var nativePagination = document.querySelector('.pagination');
    var statusEl = document.querySelector('[data-twe-status]');
    var gridEl = document.querySelector('[data-twe-grid]');
    if (!nativeGrid || !gridEl) return;

    var originalGridHTML = nativeGrid.innerHTML;
    var originalPaginationDisplay = nativePagination ? nativePagination.style.display : '';

    function renderIntoNativeGrid(cards) {
      // Clear native grid and fill with filtered product cards
      nativeGrid.innerHTML = '';
      cards.forEach(function (card) { nativeGrid.appendChild(card); });
      if (nativePagination) nativePagination.style.display = 'none';
    }

    function restoreNativeGrid() {
      nativeGrid.innerHTML = originalGridHTML;
      if (nativePagination) nativePagination.style.display = originalPaginationDisplay;
    }

    // Fetch Liquid-rendered card for a product handle
    function fetchCard(handle) {
      return fetch('/products/' + encodeURIComponent(handle) + '?view=card')
        .then(function (r) { return r.ok ? r.text() : ''; })
        .catch(function () { return ''; });
    }

    // Update URL to reflect active filters
    function updateUrl() {
      var params = new URLSearchParams();
      document.querySelectorAll('.twe-filters__group').forEach(function (group) {
        var label = group.querySelector('.twe-filters__group-toggle');
        if (!label) return;
        group.querySelectorAll('input[type="checkbox"]:checked').forEach(function (cb) {
          var key = 'filter_' + label.textContent.trim();
          var existing = params.get(key);
          params.set(key, existing ? existing + ',' + cb.value : cb.value);
        });
      });
      var qs = params.toString();
      history.replaceState(null, '', window.location.pathname + (qs ? '?' + qs : ''));
    }

    // Watch twe-grid for changes — when our API populates it with handles, render them into the native grid
    var lastHandles = [];
    new MutationObserver(function () {
      var cards = gridEl.querySelectorAll('[data-product-handle]');

      if (cards.length === 0) {
        // No results / cleared — check if status says 0 or grid is empty
        var statusText = statusEl ? statusEl.textContent : '';
        if (statusText === '' || statusText.match(/^0 /)) {
          restoreNativeGrid();
          updateUrl();
        }
        return;
      }

      var handles = Array.from(cards).map(function (c) { return c.getAttribute('data-product-handle'); });
      if (JSON.stringify(handles) === JSON.stringify(lastHandles)) return;
      lastHandles = handles;

      // Fetch all cards in parallel, then render into native grid
      Promise.all(handles.map(fetchCard)).then(function (htmls) {
        var rendered = [];
        htmls.forEach(function (html) {
          if (!html.trim()) return;
          var temp = document.createElement('div');
          temp.innerHTML = html.trim();
          if (temp.firstElementChild) rendered.push(temp.firstElementChild);
        });
        if (rendered.length) {
          renderIntoNativeGrid(rendered);
          if (window.lazySizes) window.lazySizes.autoSizer.checkElems();
        }
      });

      updateUrl();
    }).observe(gridEl, { childList: true, subtree: false });

    // Also watch status element: when it goes blank (clear all), restore
    if (statusEl) {
      new MutationObserver(function () {
        if (!statusEl.textContent.trim()) {
          lastHandles = [];
          restoreNativeGrid();
          updateUrl();
        }
      }).observe(statusEl, { childList: true, characterData: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
